'use strict';

/**
 * @classname GetCity
 * @classdesc 市区町村取得
 */
export default class GetCity {
	/**
	 * @constructor
	 * @param {jQuery} $e - .get-city
	 * @param {instance} controller - controller instance
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._controller = controller;
		$e.on('change', () => this.onChange());
	};


	/**
	 * changeのコールバック
	 *
	 * @memberof GetCity
	 * @return undefined
	 */
	onChange() {
		console.log(`${this.constructor.name}.onChange`);
		const prefecture = this._$e.val();
		if(prefecture === ''){
			$('#city').html('<option value="">--</option>');
		}else{
			this.getCity(parseInt(prefecture));
		}
	};

	/**
	 * 市区町村設定
	 *
	 * @memberof GetCity
	 * @param {number} prefecture - 都道府県コード
	 * @return undefined
	 */
	getCity(prefecture) {
		console.log(`${this.constructor.name}.getCity`);
		for(let i = 0; i < prefectures.length; i++){
			if(prefectures[i].id === prefecture){
				this._cities = prefectures[i].cities;
				this.setCity()
			}
		}
	};


	/**
	 * 市区町村設定
	 *
	 * @memberof GetCity
	 * @return undefined
	 */
	setCity() {
		console.log(`${this.constructor.name}.setCity`);
		let options = '<option value="">選択してください</option>';
		for(let i = 0; i < this._cities.length; i++){
			options += `<option value="${this._cities[i]}">${this._cities[i]}</option>`;
		}
		$('#city').html(options);
	};
};
